import MainComponent from "./MainComponent"
import "./App.css"
import "bootstrap/dist/css/bootstrap.min.css"

function App() {
    return (
        <div className="App">
            <MainComponent />
        </div>
    )
}

export default App
